"use client";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import DependentsInfo, {
  dependentValidationSchema,
  mapDependentToApiFormat,
  mapApiToFormFormat,
} from "./DependentsInfo";

// Create a validation schema for the form
const validationSchema = Yup.object({
  members: Yup.array()
    .of(dependentValidationSchema)
    .min(0, "Invalid members array"),
});

export default function DependentsFormWrapper({
  initialDependents = [],
  countryOptions = [],
  religionOptions = [],
  relationOptions = [],
  loadCountryOptions,
  loadReligionOptions,
  loadRelationOptions,
  onSubmit,
  readOnly = false,
  t = (text) => text, // Default translation function
}) {
  // Map API data to form format
  const initialValues = {
    members:
      Array.isArray(initialDependents) && initialDependents.length > 0
        ? initialDependents.map(mapApiToFormFormat)
        : initialDependents
        ? [mapApiToFormFormat(initialDependents)]
        : [],
  };

  const handleSubmit = (values) => {
    // Map form data back to API format
    const dependentsData = values.members.map(mapDependentToApiFormat);
    onSubmit(dependentsData);
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
      enableReinitialize
    >
      {({ isSubmitting, dirty }) => (
        <Form>
          <div className="space-y-6">
            <DependentsInfo
              countryOptions={countryOptions}
              religionOptions={religionOptions}
              relationOptions={relationOptions}
              loadCountryOptions={loadCountryOptions}
              loadReligionOptions={loadReligionOptions}
              loadRelationOptions={loadRelationOptions}
              readOnly={readOnly}
              t={t}
            />

            {!readOnly && (
              <div className="flex justify-end">
                <button
                  type="submit"
                  disabled={isSubmitting || !dirty}
                  className="px-4 py-2 bg-[#b99a51] hover:bg-[#a08a46] text-white rounded disabled:opacity-50"
                >
                  {t("Save Changes")}
                </button>
              </div>
            )}
          </div>
        </Form>
      )}
    </Formik>
  );
}
